import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Command, User, Lock, ArrowRight, Sparkles } from 'lucide-react';
import { useAuth } from '../../../context/AuthContext';
import styles from './Login.module.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setErrorMsg('');
    
    const result = await login(username, password);
    
    if (result.success) {
      navigate('/', { replace: true });
    } else {
      setErrorMsg(result.message);
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.loginWrapper}>
      <div className={styles.splitContainer}>
        
        {/* Left Side: Brand Statement & Aesthetics */}
        <div className={styles.brandSide}>
          <div className={styles.brandContent}>
            <div className={styles.logoBadge}>
              <Command size={28} strokeWidth={2.5} color="#004787" />
            </div>
            <h2 className={styles.heroTitle}>Smiify Workspace</h2>
            <p className={styles.heroSubtitle}>
              Manage your multi-store salon network, staff permissions, and operations with absolute precision.
            </p>
            <div className={styles.featurePills}>
              <span className={styles.pill}><Sparkles size={14} /> PBAC Secured</span>
              <span className={styles.pill}><Sparkles size={14} /> Multi-Store Sync</span>
            </div>
          </div>
          <div className={styles.footerText}>
            © 2026 Smiify Systems Inc. All rights reserved.
          </div>
        </div>

        {/* Right Side: Clean Login Form */}
        <div className={styles.formSide}>
          <div className={styles.formCard}>
            <div className={styles.formHeader}>
              <h3 className={styles.formTitle}>Welcome Back</h3>
              <p className={styles.formSubtitle}>Enter your admin credentials to access dashboard</p>
            </div>

            {errorMsg && (
              <div className={styles.errorBox}>
                <span>{errorMsg}</span>
              </div>
            )}

            <form onSubmit={handleLogin} className={styles.form}>
              <div className={styles.inputGroup}>
                <label className={styles.label}>Username or Email</label>
                <div className={styles.inputWrapper}>
                  <User size={18} className={styles.inputIcon} />
                  <input 
                    type="text" 
                    placeholder="Enter username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    className={styles.input}
                    required
                  />
                </div>
              </div>

              <div className={styles.inputGroup}>
                <div className={styles.passwordHeader}>
                  <label className={styles.label}>Password</label>
                  {/* <button type="button" className={styles.forgotBtn}>Forgot?</button> */}
                </div>
                <div className={styles.inputWrapper}>
                  <Lock size={18} className={styles.inputIcon} />
                  <input 
                    type="password" 
                    placeholder="••••••••"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className={styles.input}
                    required
                  />
                </div>
              </div>

              <button type="submit" className={styles.submitBtn} disabled={isLoading}>
                {isLoading ? (
                  <div className={styles.loaderWrap}>
                    <span className={styles.loader}></span>
                    <span>Authenticating...</span>
                  </div>
                ) : (
                  <>
                    <span>Access Dashboard</span>
                    <ArrowRight size={18} />
                  </>
                )}
              </button>
            </form>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Login;